import angular from "angular";
import { moduleName as recordsModule } from "../../../records";
import { contractInstanceConfig } from "./contractInstance";
import { contractContactTypeLookupConfig } from "./contractContactType";
import { contractStatusLookupConfig } from "./contractStatus";
import { contractRenewalTypeLookupConfig } from "./contractRenewalType";
import { contractNumberTypeLookupConfig } from "./contractNumberType";
import { configureLookupManagement } from "../../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "../lookupManagement";
import { contractNumberConfig } from "./contractNumber";
import { contractContactConfig } from "./contractContact";
import { contractMachineConfig } from "./contractMachines";
import { contractProcessConfig } from "./contractProcess";

export const vsModuleName = "ContractSharedConfigModule";

const module = angular
  .module(vsModuleName, [recordsModule])
  .config(contractInstanceConfig)
  .config(contractContactTypeLookupConfig)
  .config(contractStatusLookupConfig)
  .config(contractRenewalTypeLookupConfig)
  .config(contractNumberTypeLookupConfig)
  .config(contractNumberConfig)
  .config(contractContactConfig)
  .config(contractMachineConfig)
  .config(contractProcessConfig);

configureLookupManagement(module, {
  baseStateSref: "main.contract.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  defaultModifyPermission: "contractLookupModify",
});
